import { Box, Grid, Card, CardMedia, CardContent, Typography } from '@mui/material';
import homeImageSet from '../assets/images/home-image-set.png';

const Gallery = () => (
  <Box >
  <Box sx={{ px: { xs: 4, md: 20}, py: 4, textAlign: 'center' }}>
    <img src={homeImageSet} alt="Home Image Set" style={{ width: "100%", height: "auto" }} />
  </Box>
  </Box>
);

export default Gallery;
